import React from "react";
import { Flex, Text, type TextProps } from "@chakra-ui/react";
import { Button } from "ui/button";
import { TABLE_CELL_WIDTH } from "./utils";

type StickyPlanHeaderProps = {
  price: string;
  unit?: string;
  ctaText: string;
  ctaHref: string;
} & TextProps;

export function StickyPlanHeader({ price, unit, ctaText, ctaHref, ...props }: StickyPlanHeaderProps) {
  const buttonVariant = price === "Custom" ? "primary" : "secondary";

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      pos="relative"
      bg="white"
      flex={1}
      w={TABLE_CELL_WIDTH}
      maxW={TABLE_CELL_WIDTH}
      textAlign="center"
      p="smallest"
      {...props}
    >
      <Text textStyle="headline2">
        {price}
        {unit && (
          <Text as="span" textStyle="caption1" fontWeight="normal">
            {" "}
            {unit}
          </Text>
        )}
      </Text>
      <Button href={ctaHref} variant={buttonVariant} mt="smallest">
        {ctaText}
      </Button>
    </Flex>
  );
}
